/**
 * @Description 文件功能说明：账户 table 组件
 * @Author
 * @Time 2021/6/4
 */
/* HTML */
<template>
	<div :class="{'table-item-box': true, 'max-box': !showTreeBoxFlag}" :style="['1','2'].indexOf($store.getters.getUserRoleId) == -1 ? 'padding-left: 20px' : ''">
		<section style="height: 100%;">
			<!--查询工具条-->
			<el-col style="text-align: left;">
				<el-form :inline="true" :model="filters" ref="filters">
					<el-form-item>查询条件：</el-form-item>
					<el-form-item prop="roleId" style="width: 200px;" v-if="$store.getters.getUserRoleId=='1' || $store.getters.getUserRoleId=='2'">
						<TreeSelect :data="roles" :selectTree="roleSelectTree" @setSelectVal="setSelectVal" ref="treeSelect" />
					</el-form-item>
					<el-form-item prop="status" style="width: 120px;display: none;">
						<el-select v-model="filters.status" placeholder="请选择状态" clearable @change="researchAccounts">
							<el-option v-for="item in filters.state" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="account">
						<el-input v-model="filters.account" placeholder="请输入账户/姓名" clearable @keyup.enter.native="researchAccounts">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="researchAccounts"></i>
						</el-input>
					</el-form-item>
					<el-form-item style="float: right;margin: 0;">
						<el-button type="primary" icon="el-icon-plus" size="mini" trigger="click" @click="addAccount" v-if="$store.getters.getUserRoleId=='1' || $store.getters.getUserRoleId=='2'">新增账户</el-button>
					</el-form-item>
					<el-form-item style="float: right;">
						<el-button type="primary" icon="el-icon-document-add" size="mini" trigger="click" @click="registerAccount" v-if="$store.getters.getUserRoleId=='1'">注册企业账户</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<!-- 表格 -->
			<el-table :data="accounts" @sort-change="changeSort" ref="multipleTable" stripe :class="{'table': true, 'no-pagination': false}" style="height: calc(100% - 100px);">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="account" label="账户" min-width="120px" sortable :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.account">{{scope.row.account}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_name" label="姓名" min-width="120px" sortable :sort-orders="filters.sortOrders">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.userName">{{scope.row.userName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="role" label="角色" min-width="150px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.roles[0].roleName">{{scope.row.roles[0].roleName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="role" label="管理账户" min-width="100px">
					<template v-slot="scope">
						<span style="white-space: nowrap;" :title="scope.row.isAccountManager == 1 ? '是' : '否'">{{scope.row.isAccountManager == 1 ? '是' : '否'}}</span>
					</template>
				</el-table-column>
				<!-- v-if="$store.getters.getUserRoleId=='1' && !scope.row.isCurrAccount " -->
				<el-table-column label="操作" width="220px">
					<template v-slot="scope">
						<span style="cursor: pointer;margin-right: 10px;text-decoration:underline;" class="el-icon-edit" v-if="scope.row.account != 'admin'" type="text" size="mini" @click="()=>{editRow(scope.row, scope.$index)}" trigger="click"> 编辑</span>
						<span style="cursor: pointer;margin-right: 10px;text-decoration:underline;" class="el-icon-delete" v-if="!scope.row.isCurrAccount && scope.row.account != 'admin'" type="text" size="mini" @click="()=>{deleteRow(scope.row, scope.$index)}" trigger="click"> 删除</span>
						<span style="cursor: pointer;text-decoration:underline;" class="el-icon-refresh-left" type="text" size="mini" @click="()=>{resetPwd(scope.row, scope.$index)}" trigger="click"> 密码重置</span>
						<span style="cursor: pointer;text-decoration:underline;" class="el-icon-s-tools" v-if="!scope.row.isAccountManager == 1 && scope.row.roles[0].roleId == 2" type="text" size="mini" @click="()=>{setAccountManager(scope.row, scope.$index)}" trigger="click"> 设置管理账户</span>
					</template>
				</el-table-column>
			</el-table>

			<!--分页工具条-->
			<Pagination :currentPage="pagination.currentPage" :total="pagination.total" :pageSize="pagination.limit" @handleSizeChangeSub="handleSizeChangeSub" @handleCurrentChangeSub="handleCurrentChangeSub" />

			<!-- 添加账户 -->
			<AccountDialog ref="accountDialog" :roles="roles" @setTotal="setTotal" @setRow="setRow" @search="searchAccounts" />
			<!-- 注册企业账户 -->
			<RegisterAccountDialog ref="RegisterAccountDialog" :roles="roles" @setTotal="setTotal" @setRow="setRow" @search="searchAccounts" />
			
		</section>
	</div>
</template>

<script>
	// API 账户
	import ApiAccount from '@/request/api-account';
	// 组件 树形结构
	import TreeSelect from '@/components/TreeSingleSelect';
	// 组件 弹出窗 账户
	import AccountDialog from './AccountDialog';
	// 组件 弹出窗 企业账户
	import RegisterAccountDialog from './RegisterAccountDialog';
	// 组件 分页
	import Pagination from '@/components/Pagination';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 2021/6/4
		 */
		name: "AccountTable",
		/**
		 * @Des 数据接收类型
		 * @Auth
		 * @Date 2021/6/4
		 */
		props: {
			// 角色信息集合
			roles: Array,
			/**
			 * @Des 展示box
			 * @Auth
			 * @Date 2021/6/5
			 */
			showTreeBoxFlag: {
				type: Boolean,
				default: function() {
					return true
				}
			},
		},
		/**
		 * @Des 组件引用
		 * @Auth
		 * @Date 2021/6/4
		 */
		components: {
			// 选择树组件
			TreeSelect,
			// 账户弹窗组件
			AccountDialog,
			// 组件 弹出窗 企业账户
			RegisterAccountDialog,
			// 分页组件
			Pagination,
		},
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 2021/6/4
		 */
		data() {
			return {

				/**
				 * @Des 分页数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 20,
					currentPage: 1
				},
				/**
				 * @Des 查询数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				filters: {
					account: '',
					roleId: '',
					status: '1',
					state: [{
						value: '1',
						label: '启用'
					}, {
						value: '2',
						label: '禁用'
					}],
					orderBy: {
						"create_time": "desc"
					},
					sortOrders: [
						"ascending",
						"descending"
					]
				},
				// 账户信息集合
				accounts: [],
				// 项目信息集合
				// projects:{},
				/**
				 * @Des 角色树数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				roleSelectTree: {
					placeholder: '请选择角色',
					keywordFilter: false,
					showBox: false,
					childBox: false,
					parentBox: false,
				}
			}
		},
		computed: {},
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 2021/6/4
		 */
		watch: {
			pagination: {
				handler(newVal, oldVal) {
					this.searchAccounts();
				},
				immediate: false,
				deep: true,
			}
		},
		created() {
			// this.searchProjects();
		},
		/**
		 * @Des 初始化加载
		 * @Auth
		 * @Date 2021/6/4
		 */
		mounted() {
			// 查询账户信息
			this.searchAccounts();
		},
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 2021/6/4
		 */
		methods: {

			/**
			 * 重新搜索
			 * */
			researchAccounts() {
				// 交互锁
				if (this.lock) return false;
				
				this.pagination.total = 0;
				this.pagination.startNum = 0;
				this.pagination.currentPage = 1;
				
				this.searchAccounts();
			},

			/**
			 * @Des 查询账户信息
			 * @Auth
			 * @Date 2021/6/4
			 */
			searchAccounts() {
				// 交互锁
				if (this.lock) return false;
				
				// 交互锁
				this.lock = true;
				this.$request.postJsonRequest(ApiAccount.searchAccountsApi, {
					account: this.filters.account,
					roleIds: (this.filters.roleId ? [this.filters.roleId] : null),
					projectId: this.$store.state.currentProjectId,
					status: this.filters.status,
					orderBy: this.filters.orderBy,
					total: this.pagination.total,
					startNum: this.pagination.startNum,
					limit: this.pagination.limit,
				}).then(result => {
					// console.log(result);
					if(result.total > 0) {
						result.rows.forEach((row, index) => {
							let projectNames = Object.assign([], []);
							if(row.project && row.project.length > 0) {
								row.project.forEach((r, i) => {
									projectNames.push(r.projectName);
								})
							}
							row.projectNames = projectNames.join(", ");
							// 是否当前账户
							row.isCurrAccount = (row.account == this.$store.state.account);
						})
					}
					this.pagination.total = result.total;
					this.accounts = result.rows;
					
					this.$nextTick(() => {
						// 交互锁
						this.lock = false;
					});
				}).catch(error => {
					// 交互锁
					this.lock = false;
					console.error('查询账户异常', ApiAccount.searchAccountsApi, error);
				})
			},

			/**
			 * @Des 新增账户
			 * @Auth
			 * @Date 2021/6/4
			 */
			addAccount() {
				this.$refs.accountDialog.openDialog(false);
			},
			/**
			 * @Des 注册企业账户
			 * @Auth
			 * @Date 2025/10/5
			 */
			registerAccount() {
				this.$refs.RegisterAccountDialog.openDialog(false);
			},// registerAccount
			
			/**
			 * @Des 编辑账户
			 * @Auth
			 * @Date 2021/6/21
			 */
			editRow(row, index) {
				this.$refs.accountDialog.openDialog(true, row, index);
			},
			/**
			 * @Des 重置密码
			 * @Auth
			 * @Date 2021/6/22
			 */
			resetPwd(row, index) {
				this.$refs.accountDialog.openDialog('resetpwd', row, index);
			},
      setAccountManager(row, index){
        this.$confirm(
            '确认设置该账户【' + row.account + '】为管理员账户吗？', '询问', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }
        ).then(_ => {
          //console.log('confirm');

          // 删除账户 交互
          this.requestSetAccountManager(row, index);
        }).catch(_ => {
          //console.log('cancel')
        });
      },

      requestSetAccountManager(row, index){
        this.$request.postJsonRequest(ApiAccount.setAccountManagerApi, {
          accountId: row.accountId,
        }).then(result => {
          if(result.code == 0) {
            this.$message({
              message: '账户【' + row.account + '】设置成功',
              type: 'success',
              showClose: true,
              dangerouslyUseHTMLString: true
            });
            this.searchAccounts();
          } else {
            this.$message({
              message: result.msg,
              type: 'error',
              showClose: true,
              dangerouslyUseHTMLString: true
            });
          }
        }).catch(error => {
          console.error('账户设置异常', ApiAccount.setAccountManagerApi, error);
        })
      },
			/**
			 * @Des 删除账户
			 * @Auth
			 * @Date 2021/6/21
			 */
			deleteRow(row, index) {
				this.$confirm(
					'确认删除账户【' + row.account + '】？', '询问', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false,
						type: 'warning'
					}
				).then(_ => {
					//console.log('confirm');

					// 删除账户 交互
					this.requestDelete(row, index);
				}).catch(_ => {
					//console.log('cancel')
				});

			},
			/**
			 * @Des 删除账户 交互
			 * @Auth
			 * @Date 2021/6/21
			 */
			requestDelete(row, index) {
				this.$request.postJsonRequest(ApiAccount.deleteAccountApi, {
					accountIds: [row.accountId],
					// projectId: this.$store.state.currentProjectId
				}).then(result => {
					if(result.code == 0) {
						this.$message({
							message: '账户【' + row.account + '】删除成功',
							type: 'success',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						// 改变总数
						this.setTotal(0);

						// 删除登录账户
						if(row.account == this.$store.state.account) {
							// 退出登录
							this.logOut();
						}
					} else {
						this.$message({
							message: '账户【' + row.account + '】删除失败',
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
				}).catch(error => {
					console.error('账户删除异常', ApiAccount.deleteAccountApi, error);
				})
			},

			/**
			 * @Des 退出登录
			 * @Auth
			 * @Date 2021/6/21
			 */
			logOut() {
				// 移除cookie
				this.$cookies.remove("username");
				this.$cookies.remove("usernameSecret");
				this.$cookies.remove("passwordSecret");
				// 登录页面
				this.$router.replace({
					path: '/'
				}, () => {}, () => {});
			},

			/**
			 * @Des 改变总数
			 * @Auth
			 * @Date 2021/6/21
			 */
			setTotal(val) {
				this.pagination.total = val;
				if(val == 0) {
					this.pagination.currentPage = 1;
					this.pagination.startNum = 0;
				}
				// 查询list
				this.searchAccounts();
			},
			/**
			 * @Des 更新列表
			 * @Auth
			 * @Date 2021/6/21
			 */
			setRow(row, index) {
				//console.log(row, index);return false;
				this.accounts[index].role = row.role;
				this.accounts[index].userName = row.userName;
				this.accounts[index].remarks = row.remarks;
			},

			/**
			 * @Des 选择值改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			setSelectVal(val) {
				if(val) {
					this.filters.roleId = val.id;
					this.$refs['treeSelect'].setSelectVal(val);
				} else {
					this.filters.roleId = '';
					this.$refs['treeSelect'].setSelectVal();
				}
				this.researchAccounts();
			},

			/**
			 * @Des 当前页数据改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			handleCurrentChangeSub(val) {
				this.pagination.currentPage = val;
				this.pagination.startNum = this.pagination.limit * (val - 1);
			},
			/**
			 * @Des 页长度改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			handleSizeChangeSub(val) {
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
			},
			/**
			 * 改变排序
			 * */
			changeSort(data) {
				let prop = data.prop;
				let order = data.order;
				if(order == null) {
					order = this.filters.orderBy[prop];
				} else {
					order = order.replace("ending", "");
				}
				if(order != null) {
					this.filters.orderBy = {};
					this.filters.orderBy[prop] = order;
				}
				this.researchAccounts();
			},
		},
	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_pages/Account/AccountTable.vue